/**
 * Bridges deed template "Scrutiny Table Content" with the dynamic verification
 * checklist sample: snapshots plain text for dropdown option lines.
 */

export const SCRUTINY_CHECKLIST_LS_KEY = "lawhands_checklist_scrutiny_table";
export const SCRUTINY_CHECKLIST_META_KEY = "lawhands_checklist_scrutiny_meta";

export function persistScrutinyTableForChecklist(scrutinyTable: string, templateId?: number): void {
  try {
    localStorage.setItem(SCRUTINY_CHECKLIST_LS_KEY, scrutinyTable ?? "");
    localStorage.setItem(
      SCRUTINY_CHECKLIST_META_KEY,
      JSON.stringify({
        templateId: templateId ?? null,
        at: new Date().toISOString(),
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function readScrutinyTableSnapshotFromLocalStorage(): string {
  try {
    return localStorage.getItem(SCRUTINY_CHECKLIST_LS_KEY) ?? "";
  } catch {
    return "";
  }
}

/**
 * Turn scrutiny table HTML / text into one dropdown option per logical line.
 */
export function parseScrutinyTableTextToDropdownLines(text: string): string[] {
  if (!text || !String(text).trim()) return [];
  let t = String(text);
  t = t.replace(/<br\s*\/?>/gi, "\n").replace(/<\/(p|div|tr|li)>/gi, "\n");
  t = t.replace(/<[^>]+>/g, " ");
  t = t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const raw = t.split(/\n+/);
  const lines = raw
    .map((s) =>
      s
        .replace(/\s+/g, " ")
        .replace(/^\s*\d+[\.)]\s+/, "")
        .trim()
    )
    .filter((s) => s.length > 0);
  return [...new Set(lines)];
}
